/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const custom = /* GraphQL */ `
  query Custom {
    custom {
      id
      title
      description
      steps {
        items {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      tenantID
      speaker {
        firstName
        lastName
        fullName
        bio
        title
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        profile
        headshotPath
      }
      publishState
      exportVideoState
      unauthenticatedAccessAllowed
      owner
      createdAt
      updatedAt
      publishedAt
      publishedWithTranscript
      previewedAt
      cardDetails {
        cardColor
        cardShade
        thumbnailImg
        thumbnailCustomName
        thumbnailCustomPath
        thumbnailImageService
        useCustomThumbnail
        colorLeft
        colorRight
        thumbnailLarge
        thumbnailSmall
      }
      preview
      isInGiideStudioLibrary
      giideLibraryId
      useOwnDescription
      useOwnAuthorBio
      useGiideTones
      script
      hasChapters
      noindex
      embedCodeState
      embedCodeAllowedDomains
      passwordEnabled
    }
  }
`;
export const getUrl = /* GraphQL */ `
  query GetUrl($input: GetUrlInput) {
    getUrl(input: $input) {
      success
      error
      url
      fields
    }
  }
`;
export const getUrlMetaData = /* GraphQL */ `
  query GetUrlMetaData($url: String!) {
    getUrlMetaData(url: $url) {
      title
      image
      logo
      publisher
    }
  }
`;
export const getPollQuizResponsesStudio = /* GraphQL */ `
  query GetPollQuizResponsesStudio($giideId: String!) {
    getPollQuizResponsesStudio(giideId: $giideId) {
      feedCardId
      pollQuizAnswers {
        index
        text
        sortOrder
        percentResponse
      }
      totalResponses
    }
  }
`;
export const getPlan = /* GraphQL */ `
  query GetPlan {
    getPlan {
      id
      versionID
      updatedAt
      createdAt
      price
      name
      features {
        giideMaxLengthAudio {
          name
          createdAt
          isActive
          giideLengthInSeconds
          updatedAt
        }
        giideMaxFileSizeAudio {
          name
          createdAt
          isActive
          giideMaxFileSizeMBAudio
          updatedAt
        }
        giideMaxNumberOfGiides {
          createdAt
          hasLimit
          isActive
          limitAmount
          name
          updatedAt
        }
        chapters {
          name
          createdAt
          isActive
          hasLimit
          maxNumberOfChapters
          allowChaptersWithFutureGiides
          allowChaptersWithExistingGiides
          updatedAt
        }
        recording {
          name
          createdAt
          hasBrowserRecording
          updatedAt
        }
        embedCode {
          name
          createdAt
          isActive
          updatedAt
          allowEmbedCode
        }
        pollQuizFeature {
          name
          createdAt
          isActive
          updatedAt
          allowFeature
        }
        giidePasswordProtection {
          allowGiidePasswordProtection
          createdAt
          isActive
          name
          updatedAt
        }
        giideDuplicate {
          allowGiideDuplicate
          createdAt
          isActive
          name
          updatedAt
        }
      }
      userID
      tenantID
      giidesCreatedListFreePlan {
        giideID
        createdAt
        updatedAt
      }
      giidesCreatedListProPlan {
        giideID
        createdAt
        updatedAt
      }
      subscriptionIDs
      accountStatus
      freeTrialEndDate
      totalGiidesCreated
      upgradePlans
      downgradePlans
      planChangeError
      paddlePlanID
    }
  }
`;
export const getAiChatHistory = /* GraphQL */ `
  query GetAiChatHistory($giideId: ID!) {
    getAiChatHistory(giideId: $giideId) {
      chatHistory {
        type
        content
      }
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile {
    getUserProfile {
      role
      userID
      email
      fullName
      title
      profileImageName
      profileImageService
      profileImageId
      preferences {
        firstLoginVideo
        dontShowPublishInfoTooltip
        dontShowFeedcardWordTooltip
        dontShowGetStartedModal
        dontShowTranscriptAnnouncementBanner
      }
      giidesCreatedListFreePlan {
        createdAt
        giideID
        updatedAt
      }
    }
  }
`;
export const getTranscript = /* GraphQL */ `
  query GetTranscript($giideID: String!, $recordingID: String!) {
    getTranscript(giideID: $giideID, recordingID: $recordingID) {
      transcript
    }
  }
`;
export const unsplashSearch = /* GraphQL */ `
  query UnsplashSearch($query: String!, $page: Int!) {
    unsplashSearch(query: $query, page: $page) {
      total
      offset
      results {
        id
        width
        height
        description
        alt_description
        urls {
          raw
          full
          regular
          small
          thumb
          small_s3
        }
        links {
          self
          html
          download
          download_location
        }
        user {
          id
          unsplashTrackDownload {
            type
          }
          username
          name
          first_name
          last_name
        }
      }
    }
  }
`;
export const giphySearch = /* GraphQL */ `
  query GiphySearch($query: String!, $page: Int!) {
    giphySearch(query: $query, page: $page) {
      total
      offset
      results {
        id
        type
        url
        title
        alt_description
        images {
          original {
            width
            height
            url
          }
          downsized {
            width
            height
            url
          }
        }
      }
    }
  }
`;
export const getGiideAnalytics = /* GraphQL */ `
  query GetGiideAnalytics(
    $userID: String!
    $tenantID: String!
    $giideID: String!
    $period: Int!
    $grouping: String!
    $timezoneOffset: Int!
  ) {
    getGiideAnalytics(
      userID: $userID
      tenantID: $tenantID
      giideID: $giideID
      period: $period
      grouping: $grouping
      timezoneOffset: $timezoneOffset
    ) {
      details {
        timestamp
        eventName
        count
        feedCardId
      }
      feedCardDetails {
        nonLibraryGiideID
        id
        source
        time
        title
        type
        url
        context
        affiliation
        text
        caption
        question
        feedCardIdForAnalytics
        questionHasCorrectAnswer
        customHeader
        questionType
        answerDetails {
          answerOptions {
            index
            sortOrder
            text
          }
          userAnswer
          userAnswerIsCorrect
          correctAnswerIndex
        }
        resourceType
        iconUrl
        imageUrl
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        bold
        term
        tenantID
        numbered
        listItems
        author
        owner
        createdAt
        updatedAt
        firstName
        lastName
        fullName
        expertise
        unlinked
        customImage
        customImageName
        giideId
        feedCardRecordingId
        imageDetails {
          url
          description
          altDescription
          attributionUserName
          width
          height
          attributionFirstName
          attributionLastName
          attributionFullName
          caption
          imageTypeSelected
          userUploadedImageDetails {
            customImageName
          }
        }
        htmlText
        imageService
        recording {
          id
          deleted
          length
          step {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          feedCards {
            nextToken
          }
          transcriptResults {
            transcript
          }
          tenantID
          filePath
          transcriptPath
          transcriptError
          owner
          createdAt
          updatedAt
          giideId
          libraryRecordId
        }
      }
      errorMessage
    }
  }
`;
export const getGiidePaddleAccountDetails = /* GraphQL */ `
  query GetGiidePaddleAccountDetails($subscriptionId: Int!) {
    getGiidePaddleAccountDetails(subscriptionId: $subscriptionId) {
      errorMessage
      subscriptionId
      planId
      planName
      userId
      email
      marketingConsent
      updateUrl
      cancelUrl
      subscriptionState
      signupDate
      lastPaymentAmount
      lastPaymentCurrency
      lastPaymentDate
      paymentMethod
      cardType
      lastFourDigits
      expiryDate
      nextPaymentAmount
      nextPaymentCurrency
      nextPaymentDate
    }
  }
`;
export const getGiidePaddleTransactions = /* GraphQL */ `
  query GetGiidePaddleTransactions($subscriptionId: Int!) {
    getGiidePaddleTransactions(subscriptionId: $subscriptionId) {
      errorMessage
      transactions {
        orderId
        checkoutId
        amount
        currency
        status
        createdAt
        giideUserID
        giideTenantID
        productId
        isSubscription
        isOneOff
        subscriptionId
        subscriptionStatus
        userId
        email
        marketingConsent
        receiptUrl
      }
    }
  }
`;
export const getGiide = /* GraphQL */ `
  query GetGiide($id: ID!) {
    getGiide(id: $id) {
      id
      title
      description
      steps {
        items {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      tenantID
      speaker {
        firstName
        lastName
        fullName
        bio
        title
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        profile
        headshotPath
      }
      publishState
      exportVideoState
      unauthenticatedAccessAllowed
      owner
      createdAt
      updatedAt
      publishedAt
      publishedWithTranscript
      previewedAt
      cardDetails {
        cardColor
        cardShade
        thumbnailImg
        thumbnailCustomName
        thumbnailCustomPath
        thumbnailImageService
        useCustomThumbnail
        colorLeft
        colorRight
        thumbnailLarge
        thumbnailSmall
      }
      preview
      isInGiideStudioLibrary
      giideLibraryId
      useOwnDescription
      useOwnAuthorBio
      useGiideTones
      script
      hasChapters
      noindex
      embedCodeState
      embedCodeAllowedDomains
      passwordEnabled
    }
  }
`;
export const getGiidePlayerData = /* GraphQL */ `
  query GetGiidePlayerData($id: ID!) {
    getGiidePlayerData(id: $id) {
      id
      title
      description
      steps {
        items {
          id
          title
          order
          script
          giide {
            id
            title
            description
            tenantID
            publishState
            exportVideoState
            unauthenticatedAccessAllowed
            owner
            createdAt
            updatedAt
            publishedAt
            publishedWithTranscript
            previewedAt
            preview
            isInGiideStudioLibrary
            giideLibraryId
            useOwnDescription
            useOwnAuthorBio
            useGiideTones
            script
            hasChapters
            noindex
            embedCodeState
            embedCodeAllowedDomains
            passwordEnabled
          }
          tenantID
          open
          ownRecordingUploaded
          owner
          createdAt
          updatedAt
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      tenantID
      speaker {
        firstName
        lastName
        fullName
        bio
        title
        socialUrls {
          facebook
          twitter
          linkedin
          website
        }
        profile
        headshotPath
      }
      publishState
      exportVideoState
      unauthenticatedAccessAllowed
      owner
      createdAt
      updatedAt
      publishedAt
      publishedWithTranscript
      previewedAt
      cardDetails {
        cardColor
        cardShade
        thumbnailImg
        thumbnailCustomName
        thumbnailCustomPath
        thumbnailImageService
        useCustomThumbnail
        colorLeft
        colorRight
        thumbnailLarge
        thumbnailSmall
      }
      preview
      isInGiideStudioLibrary
      giideLibraryId
      useOwnDescription
      useOwnAuthorBio
      useGiideTones
      script
      hasChapters
      noindex
      embedCodeState
      embedCodeAllowedDomains
      passwordEnabled
    }
  }
`;
export const listGiides = /* GraphQL */ `
  query ListGiides(
    $filter: ModelGiideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGiides(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        steps {
          items {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          nextToken
        }
        tenantID
        speaker {
          firstName
          lastName
          fullName
          bio
          title
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          profile
          headshotPath
        }
        publishState
        exportVideoState
        unauthenticatedAccessAllowed
        owner
        createdAt
        updatedAt
        publishedAt
        publishedWithTranscript
        previewedAt
        cardDetails {
          cardColor
          cardShade
          thumbnailImg
          thumbnailCustomName
          thumbnailCustomPath
          thumbnailImageService
          useCustomThumbnail
          colorLeft
          colorRight
          thumbnailLarge
          thumbnailSmall
        }
        preview
        isInGiideStudioLibrary
        giideLibraryId
        useOwnDescription
        useOwnAuthorBio
        useGiideTones
        script
        hasChapters
        noindex
        embedCodeState
        embedCodeAllowedDomains
        passwordEnabled
      }
      nextToken
    }
  }
`;
export const getRecording = /* GraphQL */ `
  query GetRecording($id: ID!) {
    getRecording(id: $id) {
      id
      deleted
      length
      step {
        id
        title
        order
        script
        giide {
          id
          title
          description
          steps {
            nextToken
          }
          tenantID
          speaker {
            firstName
            lastName
            fullName
            bio
            title
            profile
            headshotPath
          }
          publishState
          exportVideoState
          unauthenticatedAccessAllowed
          owner
          createdAt
          updatedAt
          publishedAt
          publishedWithTranscript
          previewedAt
          cardDetails {
            cardColor
            cardShade
            thumbnailImg
            thumbnailCustomName
            thumbnailCustomPath
            thumbnailImageService
            useCustomThumbnail
            colorLeft
            colorRight
            thumbnailLarge
            thumbnailSmall
          }
          preview
          isInGiideStudioLibrary
          giideLibraryId
          useOwnDescription
          useOwnAuthorBio
          useGiideTones
          script
          hasChapters
          noindex
          embedCodeState
          embedCodeAllowedDomains
          passwordEnabled
        }
        tenantID
        open
        ownRecordingUploaded
        owner
        createdAt
        updatedAt
        recording {
          id
          deleted
          length
          step {
            id
            title
            order
            script
            tenantID
            open
            ownRecordingUploaded
            owner
            createdAt
            updatedAt
          }
          feedCards {
            nextToken
          }
          transcriptResults {
            transcript
          }
          tenantID
          filePath
          transcriptPath
          transcriptError
          owner
          createdAt
          updatedAt
          giideId
          libraryRecordId
        }
      }
      feedCards {
        items {
          nonLibraryGiideID
          id
          source
          time
          title
          type
          url
          context
          affiliation
          text
          caption
          question
          feedCardIdForAnalytics
          questionHasCorrectAnswer
          customHeader
          questionType
          answerDetails {
            userAnswer
            userAnswerIsCorrect
            correctAnswerIndex
          }
          resourceType
          iconUrl
          imageUrl
          socialUrls {
            facebook
            twitter
            linkedin
            website
          }
          bold
          term
          tenantID
          numbered
          listItems
          author
          owner
          createdAt
          updatedAt
          firstName
          lastName
          fullName
          expertise
          unlinked
          customImage
          customImageName
          giideId
          feedCardRecordingId
          imageDetails {
            url
            description
            altDescription
            attributionUserName
            width
            height
            attributionFirstName
            attributionLastName
            attributionFullName
            caption
            imageTypeSelected
          }
          htmlText
          imageService
          recording {
            id
            deleted
            length
            tenantID
            filePath
            transcriptPath
            transcriptError
            owner
            createdAt
            updatedAt
            giideId
            libraryRecordId
          }
        }
        nextToken
      }
      transcriptResults {
        items {
          alternatives {
            confidence
            content
          }
          start_time
          end_time
          type
        }
        transcript
      }
      tenantID
      filePath
      transcriptPath
      transcriptError
      owner
      createdAt
      updatedAt
      giideId
      libraryRecordId
    }
  }
`;
export const getUserAudioLibrary = /* GraphQL */ `
  query GetUserAudioLibrary($id: ID!) {
    getUserAudioLibrary(id: $id) {
      id
      audioUrl
      createdAt
      durationSeconds
      tenantID
      title
      updatedAt
      userID
      state
      errorMessage
      errorMessageDisplayToUser
      originalFileExtension
      originalFileMimeType
      uploadSource
    }
  }
`;
export const listUserAudioLibrarys = /* GraphQL */ `
  query ListUserAudioLibrarys(
    $filter: ModelUserAudioLibraryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAudioLibrarys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        audioUrl
        createdAt
        durationSeconds
        tenantID
        title
        updatedAt
        userID
        state
        errorMessage
        errorMessageDisplayToUser
        originalFileExtension
        originalFileMimeType
        uploadSource
      }
      nextToken
    }
  }
`;
export const userAudioLibraryByUserId = /* GraphQL */ `
  query UserAudioLibraryByUserId(
    $userID: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserAudioLibraryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserAudioLibraryByUserId(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        audioUrl
        createdAt
        durationSeconds
        tenantID
        title
        updatedAt
        userID
        state
        errorMessage
        errorMessageDisplayToUser
        originalFileExtension
        originalFileMimeType
        uploadSource
      }
      nextToken
    }
  }
`;
export const listUserGiidePermissionss = /* GraphQL */ `
  query ListUserGiidePermissionss(
    $email: String
    $giideID: ModelStringKeyConditionInput
    $filter: ModelUserGiidePermissionsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserGiidePermissionss(
      email: $email
      giideID: $giideID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        email
        giideID
        userID
        createdAt
        updatedAt
        tenantID
      }
      nextToken
    }
  }
`;
